import _regeneratorRuntime from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import ReactDOM from 'react-dom';
import { attachEventProps } from './utils';
import { ensureElementInBody, dashToPascalCase } from './utils';
export function createOverlayComponent(tagName, controllerTagName) {
  var displayName = dashToPascalCase(tagName);
  var dismissEventName = "on".concat(displayName, "DidDismiss");
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(ReactControllerComponent, _React$Component);

      function ReactControllerComponent(props) {
        var _this;

        _classCallCheck(this, ReactControllerComponent);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactControllerComponent).call(this, props));
        _this.el = document.createElement('div');
        return _this;
      }

      _createClass(ReactControllerComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.controllerElement = ensureElementInBody(controllerTagName);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          return __awaiter(this, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var _a, children, isOpen, onDidDismiss, cProps, elementProps;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(prevProps.isOpen !== this.props.isOpen && this.props.isOpen === true)) {
                      _context.next = 12;
                      break;
                    }

                    _a = this.props, children = _a.children, isOpen = _a.isOpen, onDidDismiss = _a.onDidDismiss, cProps = __rest(_a, ["children", "isOpen", "onDidDismiss"]);
                    elementProps = Object.assign({}, cProps, _defineProperty({}, dismissEventName, onDidDismiss));

                    if (!this.controllerElement.componentOnReady) {
                      _context.next = 6;
                      break;
                    }

                    _context.next = 6;
                    return this.controllerElement.componentOnReady();

                  case 6:
                    _context.next = 8;
                    return this.controllerElement.create(Object.assign({}, elementProps, {
                      component: this.el,
                      componentProps: {}
                    }));

                  case 8:
                    this.element = _context.sent;
                    attachEventProps(this.element, elementProps);
                    _context.next = 12;
                    return this.element.present();

                  case 12:
                    if (!(prevProps.isOpen !== this.props.isOpen && this.props.isOpen === false)) {
                      _context.next = 15;
                      break;
                    }

                    _context.next = 15;
                    return this.element.dismiss();

                  case 15:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
        }
      }, {
        key: "render",
        value: function render() {
          return ReactDOM.createPortal(this.props.children, this.el);
        }
      }], [{
        key: "displayName",
        get: function get() {
          return displayName;
        }
      }]);

      return ReactControllerComponent;
    }(React.Component)
  );
}